import { generateRequest } from '.';
import { toQueryString } from '../../lib/utils/querystring';

export const Action = {
  Preferences: {
    FetchEmailSubscriptionsPending: 'SubscriptionsFetch_PENDING',
    FetchEmailSubscriptionsCompleted: 'SubscriptionsFetch_FULFILLED',
    FetchEmailSubscriptionsFailed: 'SubscriptionsFetch_FAILED',
    UpdateEmailSubscriptionsPending: 'SubscriptionsSaving_PENDING',
    UpdateEmailSubscriptionsCompleted: 'SubscriptionsSaving_FULFILLED',
    UpdateEmailSubscriptionsFailed: 'SubscriptionsSaving_FAILED',
  },
};

export const fetchEmailSubscriptions = (emailAddress, hash) => {
  const anonymous = emailAddress && hash;
  const query = anonymous ? `?${toQueryString({ email: emailAddress, hash })}` : '';

  return generateRequest({
    credentials: anonymous ? 'omit' : 'same-origin',
    endpoint: `/assets-v2/api/subscriptions${query}`,
    types: [
      Action.Preferences.FetchEmailSubscriptionsPending,
      Action.Preferences.FetchEmailSubscriptionsCompleted,
      Action.Preferences.FetchEmailSubscriptionsFailed,
    ],
  });
};

export const updateEmailSubscriptions = (subscriptions, emailAddress, hash) => {
  const anonymous = emailAddress && hash;
  const query = anonymous ? `?${toQueryString({ email: emailAddress, hash })}` : '';

  return generateRequest({
    method: 'POST',
    credentials: anonymous ? 'omit' : 'same-origin',
    endpoint: `/assets-v2/api/subscriptions${query}`,
    headers: { 'Content-Type': 'application/json' },
    body: {
      subscriptions,
    },
    types: [
      Action.Preferences.UpdateEmailSubscriptionsPending,
      Action.Preferences.UpdateEmailSubscriptionsCompleted,
      Action.Preferences.UpdateEmailSubscriptionsFailed,
    ],
  });
};
